import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import { ToastContainer, toast } from "react-toastify";
import APIClient from '../common/ApiClient'
import ConfirmDialog from '../common/ConfirmDialog'
import { Link, useOutletContext } from 'react-router-dom';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import PreviewIcon from '@mui/icons-material/Preview';

const FileUpload = () => {
    const [file, setFile] = useState(null);
    const [data, setData] = useState(null);
    const [tableData, setTableData] = useState(null);
    const [tableColumns, setTableColumns] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);

    const [selectedType, setSelectedType] = useState('NT');
    const [selectedProduct, setSelectedProduct] = useState('');
    const [currentMonth, setCurrentMonth] = useState('');
    const [currentYear, setCurrentYear] = useState('');

    const oEmailData = [];

    const onUploadWithMail = (oEvent) => {
        setIsModalOpen(false);
        _onUpload("Y");
    };
    const onUploadWithoutMail = (oEvent) => {
        setIsModalOpen(false);
        _onUpload("N");
    };
    const onUploadCancel = (oEvent) => {
        setIsModalOpen(false);
    };
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };
    const _onUpload = async (sMailSend) => {

        const formData = new FormData();
        formData.append('file', file);

        formData.append('smonth', currentMonth);
        formData.append('syear', currentYear);
        formData.append('noticetype', selectedType);

        if (selectedType === 'LRN_CC') {
            APIClient.post('/uploadLRNCC', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }).then(response => {
                toast.success(response.data.message, {
                    position: "bottom-center",
                    pauseOnHover: true,
                    delay: true
                });

                displayFileContent().then(() => {
                    console.log('LRN Uploaded and displayed on screen');
                });
            }).catch(error => {
                toast.error(error.response.data.message, {
                    position: "bottom-center",
                    pauseOnHover: true
                });
            });
        } else if (selectedType === 'SEC25_CC') {
            APIClient.post('/uploadSEC25_CC', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }).then(response => {
                toast.success(response.data.message, {
                    position: "bottom-center",
                    pauseOnHover: true,
                    delay: true
                });

                displayFileContent().then(() => {
                    console.log('SEC25 Uploaded and displayed on screen');
                });
            }).catch(error => {
                toast.error(error.response.data.message, {
                    position: "bottom-center",
                    pauseOnHover: true
                });
            });
        } else if(selectedType === 'CC') {
            APIClient.post('/upload_CC', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                } 
            }).then(response => {
                toast.success(response.data.message, {
                    position: "bottom-center",
                    pauseOnHover: true,
                    delay: true
                });

                displayFileContent().then(() => {
                    if (sMailSend === "Y")
                        _sendMail();
                });
            }).catch(error => {
                toast.error('Upload failed!', {
                    position: "bottom-center",
                    pauseOnHover: true
                });
            });
        } else {
            APIClient.post('/uploadFile', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }).then(response => {
                toast.success(response.data.message, {
                    position: "bottom-center",
                    pauseOnHover: true,
                    delay: true
                });

                displayFileContent().then(() => {
                    if (sMailSend === "Y")
                        _sendMail();
                });
            }).catch(error => {
                toast.error('Upload failed!', {
                    position: "bottom-center",
                    pauseOnHover: true
                });
            });
        }
    };
    const _sendMail = () => {
        if (oEmailData.length > 0) {
            APIClient.post('/sendMail', oEmailData).then(response => {

                toast.success(response.data.message, {
                    position: "bottom-center",
                    pauseOnHover: true,
                    delay: true
                });
            }).catch(error => {

                toast.error(error.response.data.message, {
                    position: "bottom-center",
                    pauseOnHover: true
                });
            });
        } else {
            toast.info('Email address not found!', {
                position: "bottom-center",
                pauseOnHover: true
            });
        }
    };
    const displayFileContent = async (e) => {
        // const file = e.target.files[0];

        return new Promise((resolve) => {
            if (selectedType === "NT") {
                toast.info('Please select Notice Type', {
                    position: "bottom-center",
                    pauseOnHover: true
                });
            } else if (selectedType === "CC" && selectedProduct === '') {
                toast.info('Please select a Product', {
                    position: "bottom-center",
                    pauseOnHover: true
                });
            } else if (!file) {
                toast.info('Please select an excel file', {
                    position: "bottom-center",
                    pauseOnHover: true
                });
            } else if (file) {
                var reader = new FileReader();

                reader.onload = (event) => {
                    const workbook = XLSX.read(event.target.result, { type: 'binary' });
                    const sheetName = workbook.SheetNames[0];
                    const sheet = workbook.Sheets[sheetName];
                    const sheetData = XLSX.utils.sheet_to_json(sheet);

                    if (sheetData && sheetData.length > 0 && selectedType !== "LRN_CC") {
                        for (var i = 0; i < sheetData.length; i++) {
                            var record = {};
                            record.smonth = currentMonth;
                            record.syear = currentYear;
                            record.name = sheetData[i].name;
                            record.aan16 = sheetData[i].aan16;
                            record.email = sheetData[i].email;

                            oEmailData.push(record);
                        }
                    }
                    setData(sheetData);
                    setTableData(sheetData);
                    const keys = Object.keys(sheetData.length ? sheetData[0] : {});
                    setTableColumns(keys);
                    resolve();
                };

                reader.readAsBinaryString(file);
            }
        });
    };
    const onUploadPress = () => {
        if (selectedType === "NT") {
            toast.info('Please select Notice Type', {
                position: "bottom-center",
                pauseOnHover: true
            });
        } else if (selectedType === "CC" && selectedProduct === '') {
            toast.info('Please select a Product', {
                position: "bottom-center",
                pauseOnHover: true
            });
        } else if (!file) {
            toast.info('Please select an excel file', {
                position: "bottom-center",
                pauseOnHover: true
            });
        } else {
            // setIsModalOpen(true);
            _onUpload('N');
        }
    };
    const onTypeChange = (oEvent) => {
        setSelectedProduct('');
        setSelectedType(oEvent.target.value);
    };
    useEffect(() => {
        const sMonth = localStorage.getItem('month');
        const sYear = localStorage.getItem('year');
        setCurrentMonth(sMonth);
        setCurrentYear(sYear);
    }, []);

    return (
        <div className='childPage'>
            <div className='hBox' style={{ padding: '10px', backgroundColor: '#f4f4f4', marginBottom: '20px', border: 'solid 1px #e7e2e2' }}>
                {/* <label style={{ width: '70px', textAlign: 'right' }}>Notice Type:</label> */}
                <select style={{ width: '150px' }} value={selectedType} onChange={(e) => { onTypeChange(e) }} >
                    <option value="NT">Select Notice Type</option>
                    <option value="CC">Credit Card</option>
                    <option value="LRN_CC">LRN - Credit Card</option>
                    <option value="SEC25_CC">Section 25 - Credit Card</option>
                    <option value="HL" disabled>Home Loan</option>
                    <option value="PL" disabled>Personal Loan</option>
                </select>
                {selectedType === 'CC' &&
                    <select style={{ width: '150px' }} value={selectedProduct} onChange={(e) => setSelectedProduct(e.target.value)}>
                        <option value="">Select Product</option>
                        <option value="OTS">OTS</option>
                        <option value="OTS" disabled>BSN</option>
                        <option value="OTS" disabled>CIBIL</option>
                        <option value="OTS" disabled>Concilation</option>
                        <option value="OTS" disabled>CCML-ABUSE</option>
                        <option value="OTS" disabled>DECEASED-LH</option>
                        <option value="OTS" disabled>DNC-WO</option>
                        <option value="OTS" disabled>DNC-CF</option>
                        <option value="OTS" disabled>DLN notice</option>
                    </select>
                }
                {/* </div>
            <div className='hBox'> */}
                {/* <label style={{ width: '70px', textAlign: 'right' }}>File:</label> */}
                <input type="file" onChange={handleFileChange} accept='.xls,.xlsx' />

                {/* <button onClick={onUploadPress}>Upload</button> */}
                <button name='upload' onClick={onUploadPress} style={{ alignItems: 'center', display: 'flex' }}><FileUploadIcon style={{ width: '.6em', height: 'unset', marginRight: '5px' }}></FileUploadIcon>Upload</button>
                {
                    <ConfirmDialog
                        sTitle='Confirmation'
                        msgText='Do you want to send mail as well ?'
                        sYesBtnText='Yes'
                        sNoBtnText='No'
                        isOpen={isModalOpen}
                        onClose={onUploadWithoutMail}
                        onConfirm={onUploadWithMail}
                        onHeaderClose={onUploadCancel}
                    />
                }
                <button name='view' onClick={displayFileContent} style={{ alignItems: 'center', display: 'flex' }}><PreviewIcon style={{ width: '.6em', height: 'unset', marginRight: '5px' }}></PreviewIcon>View</button>
            </div>
            {/* {data && ( */}
            <div style={{ marginTop: '35px', borderRadius: '5px', border: 'solid 1px #e7e2e2' }}>
                {data && (
                    <div style={{ height: '35px', alignContent: 'center' }} className='tableHeader'>
                        <label className='labelHeading'>Records({data && data.length})</label>
                    </div>
                )}
                {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
                {data ? (
                    <div className="table-container">
                        <table>
                            <thead>
                                <tr>
                                    {tableColumns.map((item, idx) => (
                                        <th key={idx}>{item}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {tableData.map((item, idx) => (
                                    <tr key={idx}>
                                        {tableColumns.map((key, idx) => (
                                            <td data-label={key}>
                                                {/* <p>
                                                    {isExpanded ? item[key].toString() : `${item[key].toString().slice(0, maxLength)}${item[key].toString().length > maxLength ? '...' : ''}`}
                                                </p>
                                                {item[key].toString().length > maxLength && (
                                                    <Link onClick={toggleText}>
                                                        {isExpanded ? 'less' : 'more..'}
                                                    </Link>
                                                )} */}

                                                {item[key]}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (<div className='noDataDiv'>No Data</div>)}

            </div>
            {/* )} */}
            <div>
                <ToastContainer></ToastContainer>
            </div>
        </div>
    );
};

export default FileUpload;
